export class FITH2GameConfig {
    public static reel_num: number = 6;
    public static reelsNum: number = 6;
    public static reelHeight: number = 600;
    public static symbolHeight: number = 100;
    public static symbolWidth: number = 120;
    public static fsSymbolWidth: number = 100;
    public static defaultGameAreaSize: number[] = [6, 6, 6, 6, 6, 6];
    public static reelAreaPos: PIXI.Point = new PIXI.Point(60, 60);
    public static fsReelAreaPos: PIXI.Point = new PIXI.Point(0, 0);
    public static reelAreaMaskPos: PIXI.Point = new PIXI.Point(0, 0);
    public static reelPositions: PIXI.Point[] = [
        new PIXI.Point(0, 50),
        new PIXI.Point(0 + FITH2GameConfig.symbolWidth, 50),
        new PIXI.Point(0 + FITH2GameConfig.symbolWidth * 2, 50),
        new PIXI.Point(0 + FITH2GameConfig.symbolWidth * 3, 50),
        new PIXI.Point(0 + FITH2GameConfig.symbolWidth * 4, 50),
        new PIXI.Point(0 + FITH2GameConfig.symbolWidth * 5, 50),
        new PIXI.Point(0 + FITH2GameConfig.symbolWidth * 6, 50)
    ];
    public static fsReelPositions: PIXI.Point[] = [
        new PIXI.Point(60, 110),
        new PIXI.Point(60 + FITH2GameConfig.fsSymbolWidth, 110),
        new PIXI.Point(60 + FITH2GameConfig.fsSymbolWidth * 2, 110),
        new PIXI.Point(60 + FITH2GameConfig.fsSymbolWidth * 3, 110),
        new PIXI.Point(60 + FITH2GameConfig.fsSymbolWidth * 4, 110),
        new PIXI.Point(60 + FITH2GameConfig.fsSymbolWidth * 5, 110),
        new PIXI.Point(60 + FITH2GameConfig.fsSymbolWidth * 6, 110)
    ];
    public static DEFAULT_WAYS: number = 729;
    public static WIN_CAP: number = 65000;
    public static SYMBOL_HIGHLIGHT_DURATION: number = 0.2;
}